import authHeaders from 'helpers/auth-header';
import request from './api';

function getBranchesByMerch(vkn) {
  return request({
    url: `/branch/individual/identification-number/${vkn}`,
    method: 'GET',
    headers: authHeaders(),
  });
}

function addBranch(identificationNumber, body) {
  return request({
    url: `/branch/individual/identification-number/${identificationNumber}`,
    method: 'POST',
    headers: authHeaders(),
    data: { ...body },
  });
}

function updateBranch(identificationNumber, body) {
  return request({
    url: `/branch/individual/identification-number/${identificationNumber}`,
    method: 'PUT',
    headers: authHeaders(),
    data: { ...body },
  });
}

function getBranchDetail(vkn, branchId) {
  return request({
    url: `/branch/get-branch/identification-number/${vkn}/branch-id/${branchId}`,
    method: 'GET',
    headers: authHeaders(),
  });
}

function deleteBranch(branchId) {
  return request({
    url: `/branch/close/branch-id/${branchId}`,
    method: 'DELETE',
    headers: authHeaders(),
  });
}

function getBranchReportsExcel(identificationNumber) {
  return request({
    url: `branch/identification-number/${identificationNumber}/excel`,
    method: 'GET',
    headers: authHeaders(),
    responseType: 'arraybuffer',
    accept: '*/*',
  });
}

const branch = {
  getBranchesByMerch,
  getBranchDetail,
  addBranch,
  updateBranch,
  deleteBranch,
  getBranchReportsExcel,
};

export default branch;
